import {Button} from '@vector';
import {ArrowRightBoldIcon} from '@solar-icons/react';
import HeroWidgets from './HeroWidgets';
import styles from './Hero.module.css';

const HOTMATHS_WORDMARK_URL = '/assets/branding/home/hotmaths-logo-aligned-accessible-orange.svg';
const CAMBRIDGE_LOGO_URL = '/assets/branding/checkpoints/cambridge-logo-text.svg';

/**
 * The page's opening statement, split into a first line and a last word (e.g. "Cambridge" / "HOTmaths"),
 * shown as the Cambridge text logo above the HOTmaths wordmark - presentational only, `content.intro.heading`
 * itself is untouched and supplies the images' alt text.
 */
function splitHeading(heading) {
    const words = heading.trim().split(' ');
    const highlight = words.pop();
    return {lead: words.join(' '), highlight};
}

export default function Hero({content}) {
    const {lead, highlight} = splitHeading(content.heading);

    return (
        <section className={styles.hero}>
            <div className={styles.inner}>
                <div className={styles.text}>
                    <h1 className={styles.heading}>
                        {lead && (
                            <span className={styles.highlight}>
                                <img className={styles.highlightLogo} src={CAMBRIDGE_LOGO_URL} alt={lead}/>
                            </span>
                        )}
                        <span className={styles.headingLine}>
                            <img className={styles.headingLogo} src={HOTMATHS_WORDMARK_URL} alt={highlight}/>
                        </span>
                        {content.edition && <span className={styles.edition}>{content.edition}</span>}
                    </h1>
                    <p className={styles.standfirst}>{content.standfirst}</p>
                    <div className={styles.actions}>
                        <Button surface="accent" size="large" href={content.primaryAction.href}
                                icon={<ArrowRightBoldIcon size={20}/>} iconPosition="end">
                            {content.primaryAction.label}
                        </Button>
                        <Button size="large" href={content.secondaryAction.href}>
                            {content.secondaryAction.label}
                        </Button>
                    </div>
                </div>

                <div className={styles.visualWrap}>
                    <HeroWidgets/>
                </div>
            </div>
        </section>
    );
}
